import React, { useState } from 'react';
import './style.scss';
import Dropdown from '../Dropdown';
import { locationDropDownConfig } from '../../../utils/Constant';
import { ReactComponent as LocationIcon } from '../../../Assets/location.svg';
import { ReactComponent as LocationMobile } from '../../../Assets/location_web.svg';
import { ReactComponent as SearchMobile } from '../../../Assets/majesticons_search-line.svg';
import { ReactComponent as Logo } from '../../../Assets/logo.svg';

import { Link, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import AutoCompleteInputBar from '../AutoCompleteInputBar';
import {
  addFilter,
  getAllEvents,
  getAllFilterEvents,
} from '../../../Redux/slices/eventSlice';
import PropTypes from 'prop-types';
import { useMediaQuery } from 'react-responsive';

const SearchHeader = (props) => {
  const { styleClass, showSearchBar, blackMode = false } = props;
  const isMobile = useMediaQuery({ maxWidth: 600 });
  const [mobileSearchHeader, setMobileSearchHeader] = useState(false);

  SearchHeader.propTypes = {
    styleClass: PropTypes.string,
    showSearchBar: PropTypes.bool,
  };

  const dispatch = useDispatch();
  const { location: filterLocation } = useSelector(
    (state) => state.event.filter
  );
  const location = useLocation();

  const handleLocationChange = (value) => {
    dispatch(addFilter({ location: value }));
    if (location.pathname === '/') {
      dispatch(getAllEvents());
    } else {
      dispatch(getAllFilterEvents());
    }
  };

  return (
    <div
      className={`searchHeader ${styleClass}`}
      style={
        {
          // backgroundColor:
        }
      }
    >
      <Link to="/">
        <div className="border-radius-8">
          <Logo />
        </div>
      </Link>
      {showSearchBar && (isMobile ? mobileSearchHeader : true) && (
        <AutoCompleteInputBar removeSearch={isMobile} />
      )}
      <div className="dropdownWrapper flex border-radius-14">
        <LocationIcon />
        <Dropdown
          config={locationDropDownConfig}
          selectedValue={filterLocation}
          handleChange={handleLocationChange}
          showSearchBar={showSearchBar}
        />
      </div>
      <div className="dropdownWrapper-mobile flex border-radius-14">
        {!mobileSearchHeader && (
          // <SearchMobile
          //   className={!blackMode ? "stroke-black" : ""}
          //   onClick={() => setMobileSearchHeader(true)}
          // />   <LocationIcon />
          <>
            <LocationIcon />{' '}
            <Dropdown
              config={locationDropDownConfig}
              selectedValue={filterLocation}
              handleChange={handleLocationChange}
              showSearchBar={showSearchBar}
            />
          </>
          // <Dropdown
          //   config={locationDropDownConfig}
          //   selectedValue={filterLocation}
          //   handleChange={handleLocationChange}
          //   showSearchBar={showSearchBar}
          // />
        )}
        {/* <LocationMobile className={!blackMode ? 'fill-black' : ''} /> */}
      </div>
    </div>
  );
};

export default SearchHeader;
